module.exports = __webpack_public_path__ + "static/img/SC4.43d8d1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/SC4.jpg
// module id = rtD3
// module chunks = 0